import Address from '@modules/husleie-framework/src/types/Address.entity';

const enum BankAccountEnum {
  IBAN = 'IBAN',
  NORWEGIAN = 'NORWEGIAN',
}

type BankAccountType = BankAccountEnum.IBAN | BankAccountEnum.NORWEGIAN;

interface BankAccount {
  type: BankAccountType;
  firstName: null | string;
  lastName: null | string;
  address?: null | Address;
  number: null | string;
  additionalNumber?: null | string;
  transferReference?: null | string;
}

export { BankAccount, BankAccountEnum, BankAccountType };
